module.exports = __webpack_public_path__ + "zadowolenie.png?2c51bff06445a478fb851456275eb0aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zadowolenie.png
// module id = 1021
// module chunks = 2